import type { Finding, FindingStatement, Report } from '@/models/report';

/** Live rows with positions, plus a soft delete for each server row the state dropped. */
export function buildFindingPayloads(
  currentReport: Pick<Report, 'findings'>,
  findings: Record<string, FindingStatement[]>,
  classes: Iterable<string> = Object.keys(findings)
): Finding[] {
  const serverRows = currentReport.findings.filter((f) => !f.isDeleted);
  return Array.from(classes).flatMap((findingClass) => {
    const live = findings[findingClass];
    const kept = new Set(live.map((s) => s.uuid));
    return [
      ...live.map((s, index) => ({ ...s, findingClass, index })),
      ...serverRows
        .filter((f) => f.findingClass === findingClass && !kept.has(f.uuid))
        .map((f) => ({ ...f, isDeleted: true })),
    ];
  });
}
